import Vue from "vue";
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import zhLang from './zh';
import enLang from './en';

const messages = {
    'zh':{
        ...zhLang,
        
    },
    'en':{
        ...enLang,
        
    }
}

const i18n = new VueI18n({
    locale:'zh',
    messages
})


export default i18n;